<template>
  <ImageUploaderModule :moduleId="moduleId" type="virtualBackgrounds" />
</template>

<script>
import ImageUploaderModule from './ImageUploaderModule.vue';
export default {
  name: 'VirtualBackgrounds',
  components: { ImageUploaderModule },
  props: {
    moduleId: {
      type: String,
      required: true
    }
  }
};
</script>
